export const BUILD_VERSION = '1782911001';
